import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Tag} from "../../../../../../../models/tag";
import {TagControllerService} from "../../../../../../../services/form-controller/tag-controller.service";
import {BaseError} from "../../../../../base-error";

@Component({
  selector: "field-set-tag",
  templateUrl: "./field-set-tag.component.html",
  styles: [],
  providers: [TagControllerService],
})
export class FieldSetTagComponent extends BaseError implements OnInit {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();
  public tagItems: Tag[] = [];

  constructor(private tagController: TagControllerService, toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.loadAllTags();
  }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

  public loadAllTags() {
    this.tagController.getTagList().subscribe(
      (data) => this.tagItems = data,
    );
  }

  public onTagAdded(tag: any) {
    if (tag.id === tag.name) {
      tag.id = undefined;
    }
    if (tag.id === undefined) {
      this.tagController.createTag(tag.name).subscribe(
        (data) => {
          tag = data;
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

}
